import React from 'react'
import PropTypes from 'prop-types'
import { Breadcrumb, Breadcrumbs, Typography } from '@chilecompra/react-kit/components'
import { Navigation, Root } from './HeadingSection.styles'

/**
 * The HeadingSection's container.
 */
const HeadingSection = ({ breadcrumbs, title, subtitle }) => {
  return (
    <Root>
      {breadcrumbs && (
        <Navigation>
          <Breadcrumbs>
            {breadcrumbs.map((breadcrumb, index) => (
              <Breadcrumb
                key={`breadcrumb____${index}`}
                to={breadcrumb.to}
                type={breadcrumb.type}
                variant={breadcrumb.variant}
                // eslint-disable-next-line react/jsx-handler-names
                onClick={breadcrumb.onClick}
              >
                {breadcrumb.children}
              </Breadcrumb>
            ))}
          </Breadcrumbs>
        </Navigation>
      )}
      {title && (
        <Typography fontWeight="bold" margin="2.3rem 0 0.2rem" variant="h2">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography margin="0 0 48px" variant="body2">
          {subtitle}
        </Typography>
      )}
    </Root>
  )
}

HeadingSection.defaultProps = {
  breadcrumbs: [],
  title: ''
}

HeadingSection.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.string.isRequired,
      to: PropTypes.string,
      type: PropTypes.string,
      variant: PropTypes.string,
      onClick: PropTypes.func
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
}

export default HeadingSection
